import vendorStatusService from "../../../../services/procurementService/vendorStatusService";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_VENDORSTATUSES } from "../../../../utils/constants";
import { VendorStatusInterface } from "../../../../models/ProcurementModule/VendorStatus";

const useVendorStatus = (page: number, pageSize: number) =>
  useQuery<VendorStatusInterface[], Error>({
    queryKey: [CACHE_KEY_VENDORSTATUSES, page, pageSize],
    queryFn: () => vendorStatusService.GetAll(page, pageSize),
    initialData: [],
  });

export default useVendorStatus;
